import { render, staticRenderFns } from "./InputText.vue?vue&type=template&id=723b02ec&scoped=true"
import script from "./InputText.vue?vue&type=script&lang=js"
export * from "./InputText.vue?vue&type=script&lang=js"
import style0 from "./InputText.vue?vue&type=style&index=0&id=723b02ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723b02ec",
  null
  
)

export default component.exports